import {useEffect, useMemo, useState} from "react";
import {get_report_years} from "../../../redux/reports";
import {MONTHS, today} from "./utils";

/** @module Pages/Reports/SlicerState */

export const MONTH_OPTIONS = MONTHS.map((label, index) => ({value: index + 1, label}));

/**
 * Estado de los segmentadores de una página. Por defecto: año y mes actuales.
 * @param {string} token
 * @returns {{slicers: object, set: function, yearOptions: array}}
 */
const useSlicers = (token) => {
    const [slicers, setSlicers] = useState(() => ({...today(), nombre: null, centro: null}));
    const [years, setYears] = useState([]);

    useEffect(() => {
        let active = true;
        if (!token) return undefined;
        get_report_years(token).then((data) => active && setYears(data)).catch(() => active && setYears([]));
        return () => {
            active = false;
        };
    }, [token]);

    const yearOptions = useMemo(() => years.map((y) => ({value: y, label: String(y)})), [years]);
    const set = (key) => (value) => setSlicers((prev) => ({...prev, [key]: value}));

    return {slicers, set, yearOptions};
};

export default useSlicers;
